import { render, staticRenderFns } from "./StickySideBar.vue?vue&type=template&id=12c8e18a&scoped=true&"
import script from "./StickySideBar.vue?vue&type=script&lang=ts&"
export * from "./StickySideBar.vue?vue&type=script&lang=ts&"
import style0 from "./StickySideBar.vue?vue&type=style&index=0&id=12c8e18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c8e18a",
  null
  
)

export default component.exports